import React, {Component} from 'react'
import {connect} from 'react-redux'
import {arrayMove} from 'react-sortable-hoc';
import CategoryAccordion from "../../common/category-accordion";
import {history} from '../../../../../store'
import ConfirmPopup from "../../../../common/confirm-popup";
import {deleteBrand, reorderBrands} from '../../../../../actions/brands'

class BrandsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      delete: {
        show: false
      }
    }
  }

  toggleDeletePopup = (id) => {
    this.setState({delete: {show: !this.state.delete.show, id: id}});
  };

  handleDelete = (result) => {
    const id = this.state.delete.id;
    this.setState({delete: {show: false}});
    if(result) {
      this.props.dispatch(deleteBrand(id));
    }
  };

  handleEdit = (id) => {
    history.push(`/admin/brands/${id}`);
  };

  handleSort = (categoryId, brandId, oldIndex, newIndex) => {
    if(oldIndex !== newIndex){
      const category = this.props.brands.find(category => category.id === categoryId);
      const newOrdering = arrayMove(category.attributes.brands, oldIndex, newIndex);
      this.props.dispatch(reorderBrands(categoryId, newOrdering))
    }
  };

  render(){
    return(
      <div>
        <CategoryAccordion categories={this.props.brands}
                           itemName="brands"
                           statusAttribute="status"
                           onDelete={this.toggleDeletePopup}
                           onEdit={this.handleEdit}
                           onSortEnd={this.handleSort}/>

        {
          this.state.delete.show &&
          <ConfirmPopup header="DELETE BRAND?"
                        onClose={this.handleDelete}>
            <p>Are you sure you want to delete this brand?</p>
          </ConfirmPopup>
        }
      </div>
    )
  }
}

export default connect()(BrandsList)


// WEBPACK FOOTER //
// ./src/components/admin/products/brands/list/brands-list.jsx